export default function splice(collection, index, ...rest) {
  return [
    ...collection.slice(0, index),
    ...rest,
    ...collection.slice(index+1)
  ]
}